import { useMutation, useQueryClient } from '@tanstack/react-query';

interface CreateTagParams {
  name: string;
  description?: string;
  color_hex: string;
}

/**
 * 求人タグを作成するフック
 */
export default function useCreateJobPostTag() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async (params: CreateTagParams) => {
      const response = await fetch('/agent/api/custom_tags', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          custom_tag: {
            ...params,
            tag_type: 'provided_job_post',
          },
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to create tag');
      }

      return response.json();
    },
    onSuccess: () => {
      // タグ一覧を再取得
      queryClient.invalidateQueries({
        queryKey: ['/agent/api/provided_job_post_tags'],
      });
    },
  });
}
